import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { Place } from '@mui/icons-material';
import { Grid2, Typography } from '@mui/material';
import { CharacterCounter, GoogleMap, GooglePlacesAutocomplete, Textarea } from '@utriper/core-ui';
import { Container, Label } from 'modules/Experience/ExperienceWizard/styles';

const MeetingPointField = ({ values, translate = () => {} }) => {
    return (
        <Container>
            <Label>{translate('meeting_point')}</Label>
            <Field name="meetingPointData" component={GoogleMap} label={translate('meeting_point_placeholder')} style={{ width: '100%' }} mode="view" input={{ value: values.locationData }} />
            {values?.meetingPointData?.location && (
                <Grid2 container size={12} alignItems="center" mt={1} flexWrap="nowrap" spacing={1}>
                    <Grid2 size={1}>
                        <Place sx={{ color: '#131313' }} />
                    </Grid2>
                    <Grid2 size={11}>
                        <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313' }} nowrap>
                            {values.meetingPointData.location}
                        </Typography>
                    </Grid2>
                </Grid2>
            )}
        </Container>
    );
};

const LocationFormFields = ({ order = 0 }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.${key}`);
    const { values, errors } = useFormState();

    return (
        <Grid2 container size={12} spacing={1}>
            <Grid2 container size={order === 0 ? 12 : { xs: 12, md: 6 }} direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px">
                {/* Location */}
                <Container>
                    <Label>{translate('location')}</Label>
                    <Field name="locationData" component={GooglePlacesAutocomplete} label={translate('location_placeholder')} sx={{ width: '100%' }} />
                </Container>

                {/* Meeting Point */}
                {order === 0 && <MeetingPointField values={values} translate={translate} />}

                {/* Meeting Instructions */}
                <Container>
                    <Label>{translate('meeting_instructions')}</Label>
                    <Field
                        name="meetingInstructions"
                        component={Textarea}
                        placeholder={translate('meeting_instructions_placeholder')}
                        minRows={4}
                        slotProps={{
                            input: {
                                inputProps: {
                                    maxLength: 255,
                                },
                            },
                        }}
                    />
                    <CharacterCounter length={values?.meetingInstructions?.length ?? 0} maxLength={255} />
                </Container>
            </Grid2>

            {order === 1 && (
                <Grid2 container size={{ xs: 12, md: 6 }} direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px">
                    <MeetingPointField values={values} translate={translate} />
                </Grid2>
            )}
        </Grid2>
    );
};

export default LocationFormFields;
